import React from 'react';
import ServicePageLayout, { FeatureGrid, ServiceCTA } from './ServicePageLayout';
import { getService } from './serviceData';

const service = getService('cloud-services');

const offerings = [
  { title: 'Cloud Computing', desc: 'Compute, storage, and managed services on AWS and Azure, sized to your workload.' },
  { title: 'Backup & Disaster Recovery', desc: 'Automated backups and recovery plans that keep your data safe and restorable.' },
  { title: 'Cloud Migration', desc: 'Smooth, low-downtime moves from on-prem or legacy hosting into the cloud.' },
  { title: 'Managed Hosting', desc: 'Fully managed hosting so your apps stay fast, patched, and online.' },
  { title: 'Scalable Infrastructure', desc: 'Architecture that grows with you: virtualization and orchestration done right.' },
];

const CloudServices = () => (
  <ServicePageLayout service={service} h1="Cloud Services & Infrastructure">
    <p className="service-intro">
      Tavernix helps businesses move to, run on, and scale in the cloud. From migration to disaster
      recovery, we build infrastructure on AWS, Azure, and Kubernetes that stays reliable as you grow.
    </p>

    <FeatureGrid heading="What We Offer" features={offerings} />

    <ServiceCTA
      heading="Planning a move to the cloud?"
      blurb="Let's map out the right infrastructure for your business."
      label="Discuss Your Cloud Needs"
      href="mailto:info@tavernix.io?subject=Cloud%20Services%20Inquiry"
    />
  </ServicePageLayout>
);

export default CloudServices;
